/**
 * Register all shared component into vue globally
 */

import Vue from 'vue';
// Shared Components
import CardCol from './CardCol';
import Inliner from './Inliner';
import Spacer from './Spacer';
import ElTelInput from './TelInput';

const components = {
  'card-col': CardCol,
  'inliner': Inliner,
  'spacer': Spacer,
  'el-tel-input': ElTelInput,
};

Object.keys(components)
  .forEach((key) => {
    const component = components[key];
    Vue.component(`sh-${key}`, component);
  });



// WEBPACK FOOTER //
// ./src/components/Shared/index.js